/* Cart "Fits your ..." badge.
 *
 * The text comes from the Fitment line-item property, and a line-item property
 * can be set by anyone - POST /cart/add needs no token, so another site can plant
 * one in a shopper's cart. It is therefore never parsed as HTML: the value is
 * reduced to plain-text lines and written with text nodes only. The tag handling
 * below is purely cosmetic (older lines stored the fits-API message, e.g.
 * "<strong>Fits your 2015 Honda Civic</strong><br />Position: Front"); safety does
 * not depend on it, because nothing here can create markup from the value.
 *
 * Test: node docs/tests/pc-fitment-text.test.js
 */
(function (root) {
  var ENTITIES = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'", '&#039;': "'", '&nbsp;': ' ' };

  /** Stored property value -> display lines, without the "Fits your" prefix. */
  function lines(raw) {
    var v = String(raw == null ? '' : raw);
    v = v.replace(/<br\s*\/?>/gi, '\n');                 // legacy line breaks (exact form only)
    v = v.replace(/<\/?(?:strong|b|em|i)>/gi, '');       // legacy emphasis tags (exact form only)
    v = v.replace(/&(?:amp|lt|gt|quot|nbsp|#0?39);/g, function (m) { return ENTITIES[m]; });
    v = v.replace(/\s*\bPosition:\s*/i, '\nPosition: ');  // Position always starts its own line

    var out = [];
    v.split('\n').forEach(function (line) {
      line = line.replace(/\s+/g, ' ').trim();
      if (!out.length) { while (/^fits your\s+/i.test(line)) line = line.replace(/^fits your\s+/i, ''); }
      if (line) out.push(line);
    });
    return out;
  }

  /** Draw the badge into el using DOM nodes and text only - never innerHTML. */
  function render(el, raw) {
    var SVG = 'http://www.w3.org/2000/svg';
    var ls = lines(raw);

    el.textContent = '';

    var svg = document.createElementNS(SVG, 'svg');
    [['aria-hidden', 'true'], ['width', '12'], ['height', '12'], ['viewBox', '0 0 24 24'], ['fill', 'none'],
     ['stroke', 'currentColor'], ['stroke-width', '2'], ['stroke-linecap', 'round'], ['stroke-linejoin', 'round']]
      .forEach(function (a) { svg.setAttribute(a[0], a[1]); });
    var path = document.createElementNS(SVG, 'path');
    path.setAttribute('d', 'M12 3 5 5.5V11c0 4.5 3 8 7 9.5 4-1.5 7-5 7-9.5V5.5Z');
    svg.appendChild(path);
    el.appendChild(svg);

    var span = document.createElement('span');
    span.setAttribute('class', 'pc-fitment__text');
    span.appendChild(document.createTextNode('Fits your ' + (ls[0] || 'vehicle')));
    for (var i = 1; i < ls.length; i++) {
      span.appendChild(document.createElement('br'));
      span.appendChild(document.createTextNode(ls[i]));
    }
    el.appendChild(span);

    el.setAttribute('data-fitment-rendered', '1');
  }

  /**
   * fits.php `message` -> DOM nodes, never innerHTML.
   * The server escapes the vehicle text (PC-9) and wraps it as
   * "<strong>Fits your 2015 Honda Civic</strong><br />Position: Front"; only
   * that shape is honoured: <strong> on a line keeps the emphasis, <br> splits
   * lines, every other tag is dropped and entities are decoded into text.
   */
  function renderMessage(el, html) {
    el.textContent = '';
    var first = true;
    String(html == null ? '' : html).split(/<br\s*\/?>/i).forEach(function (part) {
      var strong = /^\s*<strong>/i.test(part);
      var text = part.replace(/<[^>]*>/g, '')
        .replace(/&(?:amp|lt|gt|quot|nbsp|#0?39);/g, function (m) { return ENTITIES[m]; })
        .replace(/\s+/g, ' ').trim();
      if (!text) { return; }
      if (!first) { el.appendChild(document.createElement('br')); }
      first = false;
      var node = document.createTextNode(text);
      if (strong) { var s = document.createElement('strong'); s.appendChild(node); el.appendChild(s); }
      else { el.appendChild(node); }
    });
  }

  root.PCFitmentText = { lines: lines, render: render, renderMessage: renderMessage };
})(typeof window !== 'undefined' ? window : this);
